export default __webpack_public_path__ + "static/media/amex.a71fb7c1.svg";